import style from './BrandComponent.module.css';
import Title from 'component/title/TitleComponent';

// import event1 from 'assets/home/7/event1.png'
// import event2 from 'assets/home/7/event2.png'
// import event3 from 'assets/home/7/event3.png'
// import event4 from 'assets/home/7/event4.png'
// import event5 from 'assets/home/7/event5.png'

// import event6 from 'assets/home/7/event6.png'
// import event7 from 'assets/home/7/event7.png'
// import event8 from 'assets/home/7/event8.png'


// import btn from 'assets/home/7/btn.png'

// import cert1 from 'assets/home/8/cert1.png'
// import cert2 from 'assets/home/8/cert2.png'
import event01 from 'assets/home/7/event_01.png'
import event02 from 'assets/home/7/event_02.png'
import event03 from 'assets/home/7/event_03.png'
import event04 from 'assets/home/7/event_04.png'
import event05 from 'assets/home/7/event_05.png'
import nowRoute from '../../../../redux/store'

import { useState, useEffect } from 'react';

const Brand = (props) => {
    const { } = props;
    const width = window.innerWidth;
    const [x, setX] = useState(1);

    const goToDetail = (date) => {
        window.history.pushState(null, '', `/brand-detail?date=${date}`);
        nowRoute.dispatch({ type: 'brand-detail' })
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        // 组件挂载完成时的逻辑
        console.log(`Component mounted with props:`);
        const intervalId = setInterval(() => {
            setX(x => x + 1);
        }, 5000);
        // 清理函数
        return () => {
            console.log(`Component will unmount`);
            clearInterval(intervalId)
        };
    }, []);
    return (
        <div className={style.box} >
            <Title
                className={style.title_box}
                mtX='0.71vw'
                title='品牌动态'
                subtitle='活动 合作 荣誉'
                aline='center' />

            <div className={style.event_box}>
                {/* <img src={event1} alt='' onClick={() => {
                    window.open('https://edu.cnr.cn/list/20221219/t20221219_526098739.shtml')
                }} />
                <img src={event2} alt='' onClick={() => {
                    window.open('https://page.om.qq.com/page/Or_b3dY4KEvt4153PpbcnE4w0')
                }} /> */}
                {/* <img src={event8} alt='' onClick={() => {
                    window.open('http://www.innocom.gov.cn/gqrdw/c101428/202411/bb0fe81bf9874f22b198878c534b2405.shtml')
                }} />
                <img src={event7} alt='' onClick={() => {
                    window.open('https://edu.cri.cn/20241230/e92ad54e-998e-7e82-45dd-cb5395e468b9.html')
                }} />
                <img src={event6} alt='' onClick={() => {
                    window.open('https://kjt.hunan.gov.cn/kjt/xxgk/tzgg/tzgg_1/202409/t20240926_33463866.html')
                }} />
                <img src={event4} alt='' onClick={() => {
                    window.open('https://edu.cnr.cn/eduzt/2023jyzs/dhgk/dt/20231008/t20231008_526443843.shtml')
                }} />
                <img src={event3} alt='' onClick={() => {
                    window.open('https://edu.cnr.cn/gc/20230726/t20230726_526346281.shtml')
                }} /> */}
                {/* <img src={event5} alt='' onClick={() => {
                    window.open('https://edu.cnr.cn/hd/20231225/t20231225_526533279.shtml')
                }} /> */}
                {/* <img src={btn} className={style.btn} alt='' onClick={() => {
                    console.log('查看更多')
                }} /> */}
                <div className={style.box_item} onClick={() => goToDetail('2025-03')}>
                    <div className={style.box_left}>
                        <div className={style.box_header}>
                            <span className={style.box_header_date}>2025年03月</span>
                            <span className={style.box_header_title}>冲鸭教育荣获【国家高新技术企业】</span>
                        </div>
                        <p className={style.box_content}>根据《高新技术企业认定管理办法》（国科发火〔2016〕32号）和《高新技术企业认定管理工作指引》（国科发火〔2016〕195号）有关规定，现将湖南省认定机构2024年认定报备的第一批2297家高新技术企业（企业名单详见附件）进行备案公示，公示期为10个工作日。对公示企业有异议的，请在公示期内以实名、书面形式向全国高新技术企业认定管理工作领导小组办公室反映，反映情况须客观真实，以单位名义反映情况的材料需加盖单位公章，以个人名义反映情况的材料应……</p>
                    </div>
                    <img src={event01} />
                </div>
                <div className={style.box_item} onClick={() => goToDetail('2024-12')}>
                    <div className={style.box_left}>
                        <div className={style.box_header}>
                            <span className={style.box_header_date}>2024年12月</span>
                            <span className={style.box_header_title}>冲鸭教育荣获【2024年度影响力在线教育品牌】</span>
                        </div>
                        <p className={style.box_content}>教育是民族振兴、社会进步的基石，是提高国民素质、促进人的全面发展的根本途径。12月19日，2024年国际在线教育大会顺利举办。此次大会从教育的深度改革与探索出发，汇聚教育领域顶尖的教育专家、行业先锋、知名校长、优秀的一线教育工作者以及众多权威媒体代表，旨在深度剖析当前教育领域的热点问题，探索智慧教育的最新趋势与实践路径，携手构建更加开放、包容、创新的教育生态系统。多角度、全方位地审视中国教育的变革与发展，为教育事业的蓬勃兴盛搭建起高端的对话平台与合作桥梁……</p>
                    </div>
                    <img src={event02} />
                </div>
                <div className={style.box_item} onClick={() => goToDetail('2024-09')}>
                    <div className={style.box_left}>
                        <div className={style.box_header}>
                            <span className={style.box_header_date}>2024年9月</span>
                            <span className={style.box_header_title}>冲鸭教育荣获【国家级】科技型企业认证</span>
                        </div>
                        <p className={style.box_content}>根据《科技型中小企业评价办法》（国科发政〔2017〕115号）和《科技型中小企业评价服务工作指引》（国科火字〔2022〕67号）要求，湖南省2024年第二批拟入库科技型中小企业已完成公示。公示期间，经异议核实处理等工作，共有4家企业不符合科技型中小企业条件。现将通过公示的湖南省2024年第二批5204家入库的科技型中小企业名单予以公布……</p>
                    </div>
                    <img src={event03} />
                </div>
                <div className={style.box_item} onClick={() => goToDetail('2023-10')}>
                    <div className={style.box_left}>
                        <div className={style.box_header}>
                            <span className={style.box_header_date}>2023年10月</span>
                            <span className={style.box_header_title}>央广网报导：冲鸭教育，用语言突破世界的边界</span>
                        </div>
                        <p className={style.box_content}>目前，在国际市场上仍存在巨大的小语种人才缺口，一方面是进入新时代，我国与周边国家经贸合作不断迈上新台阶，对小语种人才的需求激增，另一方面是“实战性”小语种人才的缺乏。如何培养更广泛意义上的“实战性”小语种人才，成为摆在我国教育工作者面前的一道新问题。其中冲鸭教育作为小语种培训领域的佼佼者，基于“语言是世界的边界”的品牌主张，不仅为国际市场上输送了众多优秀的小语种人才，其构建的全新小语种教育模式也为此行业注入了新鲜活力……</p>
                    </div>
                    <img src={event04} />
                </div>
                <div className={style.box_item} onClick={() => goToDetail('2023-07')}>
                    <div className={style.box_left}>
                        <div className={style.box_header}>
                            <span className={style.box_header_date}>2023年07月</span>
                            <span className={style.box_header_title}>央广网报导：冲鸭教育探索在线教育新模式</span>
                        </div>
                        <p className={style.box_content}>央广网、国际在线就冲鸭教育,举办的小语种行业分享会进行了报导。冲鸭教育不断收获行业大咖的认可，举办分享会旨在为世界各地小语种学习者提供与行业大咖交流沟通的平台，帮助语言学习者更好地掌握语言学习干货，打开眼界，提升语言学习的思维，同时也希望为社会培养、输送“实战型”小语种人才……</p>
                    </div>
                    <img src={event05} />
                </div>
            </div>

            {/* <Title
                className={style.title_box}
                mtX='0.71vw'
                title='栄誉と資格'
                subtitle='荣誉资质'
                aline='center' />

            <div className={style.cert} style={{
                backgroundImage: `url(${cert1})`,
                backgroundPositionX: `-${width > 820 ? x * 300 : x * 100}px`
            }}></div>
            <div className={style.cert} style={{
                backgroundImage: `url(${cert2})`,
                backgroundPositionX: `${width > 820 ? x * 300 : x * 100}px`
            }}></div> */}
        </div>
    );
};

export default Brand;